import Vue from "vue";
import VueCarousel from "vue-slick-carousel";
Vue.use(VueCarousel);
